export const environment = {
  production: window.env.type === 'production',
  projectName: 'Admin',
  deployment: {
    region: {
      name: window.env.regionName,
      lang: window.env.regionLang,
      currency: window.env.regionCurrency
    }
  },
  apiHost: window.env.apiHost,
  tdbmHost: window.env.tdbmHost,
  fndrHost: window.env.fndrHost,
  surveysUrl: window.env.surveysUrl,
  finderellaUrl: window.env.finderellaUrl,
  dontSearchUrl: window.env.dontSearchUrl,
  translationsUrl: `https://tolgee.prodsh-fnd.net/v2/projects/13/translations/{lng}`,
  smartyAPIHost: window.env.mysmartyHost,
  authHosts: [
    {
      host: window.env.apiHost,
      paths: ['/api/']
    },
    {
      host: window.env.mysmartyHost,
      paths: ['/api/smarty', '/api/cp']
    },
    {
      host: window.env.tdbmHost,
      paths: ['/api/']
    }
  ],
  keycloakConfig: '',
  keycloak: {
    'realm': window.env.kcRealm,
    'auth-server-url': window.env.kcAuthUrl,
    'ssl-required': 'external',
    'resource': window.env.kcResource,
    'public-client': true,
    'confidential-port': 0
  },
  requireResourceAccess: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
